<template>
<div class="chapter">
<div class="inner_page">
<p class="ach"><span class="small">ALSO BY LAURIE GRAHAM</span></p><p class="acl">The Future Homemakers of America</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GreatHusbandHu_adca-1.vue?9c4d6f94